import React, { useLayoutEffect } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';
import { TRIP_EXPENSE_PATH } from '../../../../config/paths';
import { clearTripExpense, getTripExpense } from '../../../../actions';
import Loader from '../../../common/Loader';
import Content from '../../../layout/Content';
import TripExpenseToolbar from './TripExpenseToolbar';
import NoDataResource from '../../../common/resource/NoDataResource';
import TripExpenseBasicInformationResource from './resource/TripExpenseBasicInformationResource';
import InternalResource from '../../../common/resource/InternalResource';

export const TripExpense = ({
  breadcrumbs,
  match: {
    params: { id: tripExpenseId },
  },
  tripExpense,
  loading,
  dispatchGetTripExpense,
  dispatchClearTripExpense,
}) => {
  useLayoutEffect(() => {
    dispatchGetTripExpense({ tripExpenseId });

    return () => dispatchClearTripExpense();
  }, []);

  let content = null;
  let toolbar = null;
  if (loading) content = <Loader />;
  else if (tripExpense.isEmpty()) {
    content = <NoDataResource returnPage={TRIP_EXPENSE_PATH} />;
  } else {
    const tripExpenseJSON = tripExpense.toJS();
    content = (
      <>
        <h3>Información Básica</h3>
        <TripExpenseBasicInformationResource {...tripExpenseJSON} />
        <InternalResource
          id={tripExpenseJSON.id}
          createDate={tripExpenseJSON.createDate}
          lastUpdate={tripExpenseJSON.lastUpdate}
        />
      </>
    );
    toolbar = <TripExpenseToolbar tripExpenseId={tripExpenseJSON.id} />;
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Gasto de Viaje"
      toolbar={toolbar}
      content={content}
    />
  );
};

TripExpense.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  tripExpense: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
  match: matchPropTypes.isRequired,
  dispatchGetTripExpense: PropTypes.func.isRequired,
  dispatchClearTripExpense: PropTypes.func.isRequired,
};

TripExpense.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Gasto de Viaje',
      href: TRIP_EXPENSE_PATH,
    },
    {
      text: 'Ver',
      href: '',
    },
  ],
  tripExpense: AccountingUnit.TripExpense.getIn(['current', 'content']),
  loading: !AccountingUnit.TripExpense.getIn(['current', 'activity']).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetTripExpense: getTripExpense,
  dispatchClearTripExpense: clearTripExpense,
};

export default connect(mapStateToProps, mapDispatchToProps)(TripExpense);
